import React from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { reduxSelectDistrict } from 'app/hooks/reduxSelectDistrict';
import ModulePlaceholder from 'app/components/districtModulesCommon/ModulePlaceholder';
import LoadingSkeleton from 'app/components/transferModule/content/LoadingSkeleton';
export default function TransferModulePlaceholder() {
  const {
    name
  } = useSelector(reduxSelectDistrict);
  const location = useLocation();
  const text = "Es liegen keine Transfers in den letzten 10 Tagen vor. Hier geht es zu allen Transfers aus dem Kreis ".concat(name, ".");
  // Todo: add link to District-Model as soon as this is out of beta
  return /*#__PURE__*/React.createElement(ModulePlaceholder, {
    text: text,
    buttonText: "Alle Transfers anzeigen",
    link: "".concat(location.pathname, "/transfers"),
    "data-sentry-element": "ModulePlaceholder",
    "data-sentry-component": "TransferModulePlaceholder",
    "data-sentry-source-file": "TransferModulePlaceholder.tsx"
  }, /*#__PURE__*/React.createElement(LoadingSkeleton, {
    animation: false,
    "data-sentry-element": "LoadingSkeleton",
    "data-sentry-source-file": "TransferModulePlaceholder.tsx"
  }));
}